import {breadcrumbAnatomy} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(breadcrumbAnatomy.keys);

const BreadcrumbTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      color: `black.100`,
    },
    item: {
      fontSize: `md`,
    },
  },
});

export default BreadcrumbTheme;
